<template>
  <div class="text-center">
    <Mutation
      v-show="isAdding"
      :mutation="mutation"
      @done="onDone"
      @error="onError"
      :variables="variables"
      class="text-left border rounded p-4 mt-8"
    >
      <template v-slot="{ mutate }">
        <ValidationObserver
          ref="observer"
          tag="form"
          @submit.prevent="mutate"
        >
          <div class="sm:flex sm:items-start">
            <div class="sm:mt-0 sm:text-left w-full">
              <TextInput v-model.trim="proposedNumber" name="New number" label="New number" />
            </div>
          </div>
          <div class="mt-5">
            <div class="flex justify-end">
              <span class="inline-flex rounded-md shadow-sm">
                <button type="button" @click.prevent="isAdding = false" class="py-2 px-4 border border-gray-300 rounded-md text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:ring-blue active:bg-gray-50 active:text-gray-800 transition duration-150 ease-in-out">
                  Cancel
                </button>
              </span>
              <span class="ml-3 inline-flex rounded-md shadow-sm">
                <button type="submit" class="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:ring-indigo active:bg-indigo-700 transition duration-150 ease-in-out">
                  Save
                </button>
              </span>
            </div>
          </div>

        </ValidationObserver>
      </template>
    </Mutation>
    <button v-show="!isAdding" @click="isAdding = true" class="mx-auto inline-flex items-center px-2.5 py-1.5 border border-gray-300 text-xs leading-4 font-medium rounded text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:ring-blue active:text-gray-800 active:bg-gray-50 transition ease-in-out duration-150">
      Add a number
    </button>
  </div>
</template>

<script>
import Mutation from '@/components/Mutation.vue'
import TextInput from '@/components/TextInput.vue'
import { ValidationObserver } from "vee-validate"
import StudentHomeNumberCreateMutation from '@/mutations/StudentHomeNumberCreate.gql'
import { tz }           from '@/tz'

export default {
  components: {
    Mutation,
    TextInput,
    ValidationObserver
  },

  props: {
    student: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      isAdding: false,
      proposedNumber: undefined,
      mutation: StudentHomeNumberCreateMutation
    }
  },

  methods: {
    onDone() {
      this.proposedNumber = undefined
      Bus.$emit('flash-message', {text: 'Number added', type: 'success'})
    },

    onError(e) {
      Bus.$emit('flash-message', {text: e, type: 'error'})
    }
  },

  computed: {
    variables() {
      return {
        studentId: this.student.id,
        number: this.proposedNumber,
        tz: tz()
      }
    }
  }
}
</script>
